export default __webpack_public_path__ + "static/media/settlement-back.ab6d8000.png";